module.exports = __webpack_public_path__ + "static/media/logo3.25e29b8a.webp";